export default __webpack_public_path__ + "static/media/marquise.81ebbafb.webp";